import Card from "../../components/Card"

const Testimonial = ({testimonial}) => {
  return (
  <Card className="testimonial light">
    <span className="testimonial__quote-mark" aria-hidden="true">“</span>
    <p className="testimonial__quote">
            {testimonial.quote}
        </p>
        <div className="testimonial__client">
            <div className="testimonial__client-avatar">
            <img src={testimonial.avatar} alt={`${testimonial.name} avatar`} />
        </div>
        <div className="testimonial_client-details">
            <h6>{testimonial.name}</h6>
            <small>{testimonial.profession}</small>
        </div>
        </div>
    </Card>
  )
}

export default Testimonial